const API_URL = 'http://localhost:3000/';
// const API_URL = 'https://forthsoft.com';
const SERVER_ENDPOINT = 'https://forthsoft.hordecall.net';
// const SERVER_ENDPOINT = "";

export const API_ROUTES = {
    SIGN_IN: `${SERVER_ENDPOINT}/api/login`,
    CHANGE_PASSWORD: `${SERVER_ENDPOINT}/api/changePassword`,
    CHANGE_APIKEY: `${SERVER_ENDPOINT}/api/changeApiKey`,
    WHITELISTIP: `${SERVER_ENDPOINT}/api/whitelistIP`,
    IPREQUEST: `${SERVER_ENDPOINT}/api/ip-request`,
    VIEW_WHITELIST: `${SERVER_ENDPOINT}/api/viewIpList`,
    VIEW_REQUESTS: `${SERVER_ENDPOINT}/api/view-ip-request`,
    DEL_WHITELIST: `${SERVER_ENDPOINT}/api/deleteIP`,
    UPDATE_WHITELIST: `${SERVER_ENDPOINT}/api/updateIpList`,
    VIEW_SERVICES: `${SERVER_ENDPOINT}/api/services`,
    VIEW_PRICEPOINTS: `${SERVER_ENDPOINT}/api/pricePoint`,
    GET_COUNTS: `${SERVER_ENDPOINT}/api/subscribersCount`,
    SUBSCRIBERS_COUNTS: `${SERVER_ENDPOINT}/api/getSubCount`,
    SUBSCRIBERS: `${SERVER_ENDPOINT}/api/subscribers`,
    UNSUBSCRIBERS: `${SERVER_ENDPOINT}/api/unsubscribers`,
    SERVICE_CHANNELS: `${SERVER_ENDPOINT}/api/serviceChannels`,
    CHARGING_SYNC: `${SERVER_ENDPOINT}/api/chargingSync`,
    CHARGING_UNSYNC: `${SERVER_ENDPOINT}/api/chargingUnsync`,
    ALL_COUNTS: `${SERVER_ENDPOINT}/api/count`,
    SERVICE_COUNTS: `${SERVER_ENDPOINT}/api/serviceCount`,
    TWO_FA_TOKEN: `${SERVER_ENDPOINT}/api/two-FA-token`,
    TWO_FA_CHECK: `${SERVER_ENDPOINT}/api/two-FA-check`,
    TWO_FA_TOGGLE: `${SERVER_ENDPOINT}/api/two-FA-toggle`,
    TOTAL_REVENUE: `${SERVER_ENDPOINT}/api/total-revenue`,
    DEMAND_SERVICES: `${SERVER_ENDPOINT}/api/demand-services`,
    ON_DEMAND_SERVICES: `${SERVER_ENDPOINT}/api/on-demand-services`,
    OPERATORS: `${SERVER_ENDPOINT}/api/operator`,
    DISTINCT_SERVICES: `${SERVER_ENDPOINT}/api/distinctService`,
    SERVICE_PRODUCTS: `${SERVER_ENDPOINT}/api/serviceProducts`,
    VIEW_CP_SERVICES:       `${SERVER_ENDPOINT}/view/cp/service`,
    SERVICE_REVENUE:        `${SERVER_ENDPOINT}/api/serviceRevenue`,
    SERVICE_REVENUE_WITH_DAYS: `${SERVER_ENDPOINT}/api/serviceRevenueWithDays`,

    TODAY_REVENUE: `${SERVER_ENDPOINT}/api/total-revenue-today`,
    SYNCS: `${SERVER_ENDPOINT}/api/telco-partner-sync`,
    SUBSCRIBER_COUNTS: `${SERVER_ENDPOINT}/api/subscriber-counts`,

    HOURLY_CHART: `${SERVER_ENDPOINT}/api/cp/hourly-chart-user`,

    FORGOT_PASSWORD: `${SERVER_ENDPOINT}/api/forgot-password`,
    VERIFY_RESET_TOKEN: `${SERVER_ENDPOINT}/api/verify-reset-token`,
    RESEND_TOKEN: `${SERVER_ENDPOINT}/api/resend-token`,
    RESET_PASSWORD: `${SERVER_ENDPOINT}/api/reset-password`,

    CREATE_SUB_USER: `${SERVER_ENDPOINT}/api/create-sub-user`,
    VIEW_SUB_USERS: `${SERVER_ENDPOINT}/api/view-sub-users`,
    EDIT_SUB_USER: `${SERVER_ENDPOINT}/api/edit-sub-user`,
    DELETE_SUB_USER: `${SERVER_ENDPOINT}/api/delete-sub-user`,

    SERVER_ENDPOINT,
}